define([
    "underscore",
    "backbone",
    "forms/deposit/deposit_common_form"
], function(_, Backbone, DepositCommonForm) {
    return DepositCommonForm.extend({
        url: "/rest_deposit/validate_form/neteller",

        initialize: function() {
            var that = this;
            _.extend(this.validation, {
                amount: {
                    required: true,
                    min : 1
                },
                currency_abbr: {
                    required: true,
                    oneOf: [ 'JPY', 'EUR', 'USD']
                }
            });
            _.extend( this.labels, {
                amount: "Amount",
                currency_abbr: "Currency"
            });
        }
    });
});
